import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentComponent } from './shared/components/layout/content/content.component';
import { content } from './shared/routes/routes';
import { authGuard } from './shared/guard/auth.guard';
import { environment as env } from 'src/environments/environment';

export const routes: Routes = [
  {
    path: '',
    redirectTo: env.home,
    pathMatch: 'full',
  },
  {
    path: '',
    component: ContentComponent,
    canActivate: [authGuard],
    children: content.filter((route) => !route.data?.['external'] || route.data['external'] !== true),
  },
  {
    path: '',
    children: content.filter((route) => route.data?.['external'] === true),
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then((x) => x.AuthModule),
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
